export function mediaIframe() {
    const iframes = document.querySelectorAll('.media-iframe iframe');
    if (!iframes.length) return;

    for (const iframe of iframes) {
        const w = parseFloat(iframe.getAttribute('width'));
        const h = parseFloat(iframe.getAttribute('height'));
        if (w > 0 && h > 0) {
            iframe.style.aspectRatio = `${w} / ${h}`;
            iframe.removeAttribute('width');
            iframe.removeAttribute('height');
        }

        if (!iframe.hasAttribute('loading')) iframe.loading = 'lazy';
    }
}
